class RocheModalTrigger {
    static trigger(id) {
        window.dispatchEvent(new CustomEvent('rocheModalTrigger', { detail: id }));
    }
    static close() {
        window.dispatchEvent(new CustomEvent('rocheModalClose'));
    }
}

export { RocheModalTrigger as R };

//# sourceMappingURL=roche-modal-trigger.js.map